function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDacia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("text", {
    x: 4,
    y: 25,
    style: {
      fill: "#00071c",
      font: "10px Tussilago Heavy"
    }
  }, "\n    DACIA\n  "));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDacia);
export default __webpack_public_path__ + "static/media/dacia.0054fc5d4a51c0f56fc41650eb9ab13b.svg";
export { ForwardRef as ReactComponent };